module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/Group Copy 4.png")
    },
    on: {
      "click": _vm.clickIcon
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e21b8d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Account.vue
// module id = 728
// module chunks = 1